/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import AppTextEditorContent from '../../../../common/AppTextEditorContent';

const WsDescriptionBlock = ({ entity, config }) => (
  <AppTextEditorContent content={entity.description} />
);

WsDescriptionBlock.propTypes = {
  config: PropTypes.object,
  entity: PropTypes.object
};

export default WsDescriptionBlock;
